import axios from 'axios';
import store from '../store';
import Cookies from 'js-cookie';
import { trimString } from '../utils/common';

const Instance = axios.create({
  baseURL: process.env.BASE_URL,
  withCredentials: true,
  timeout: 10000
});

// 数据请求前处理
// 只处理 'PUT', 'POST' 和 'PATCH'
Instance.defaults.transformRequest.push(data => {
  if (data) {
    if (Object.prototype.toString.call(data) !== '[object Object]') {
      return data;
    }
    try {
      let tmp = JSON.parse(data)
      tmp = trimString(tmp)
      data = JSON.stringify(tmp)
    } catch (err) {
    }
  }
  return data
})

// http request 拦截器
Instance.interceptors.request.use(
  config => {
    // 默认 token 获取
    const token = Cookies.get('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    } else {
      if (process.env.NODE_ENV === 'development' && Cookies.get('token') !== process.env.TOKEN) {
        Cookies.set('token', process.env.TOKEN)
        window.location.reload()
      } else {
        window.location = (location.origin ? location.origin : (location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : ''))) + '/account/login?ref=' + encodeURIComponent(window.location.href)
      }
    }

    // 分站头
    try {
      if (store.getters.substation) {
        config.headers.common['x-site-id'] = store.getters.substation || ''
      }
    } catch (error) {
    }

    // 平台头
    try {
      // 1=pc
      // 2=h5
      // 3=小程序
      // 4=app
      // 5=千帆
      // 6=马甲
      config.headers.common['x-platform'] = 1
    } catch (error) {
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
// http response 拦截器
Instance.interceptors.response.use(
  response => {
    // 手动处理结果
    if (response.config.manual === true) {
      return response.data
    }
    if (response.data.code === 200) {
      if (response.data.data.code === 401) {
        if (process.env.NODE_ENV === 'development' && Cookies.get('token') !== process.env.TOKEN) {
          Cookies.set('token', process.env.TOKEN)
          window.location.reload()
        } else {
          window.location = (location.origin ? location.origin : (location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : ''))) + '/account/login?ref=' + encodeURIComponent(window.location.href)
        }
      }
      return response.data.data;
    } else {
      return response.data;
    }
  },
  error => {
    return Promise.reject(error);
  }
);

export default Instance;



// WEBPACK FOOTER //
// ./src/api/service.js